import React, { useState, useEffect } from 'react';
import { AlertTriangle, Timer } from 'lucide-react';

const CountdownTimer = ({ createdAt }) => {
  const [timeLeft, setTimeLeft] = useState(null);
  
  useEffect(() => {
    const calculateTimeLeft = () => {
      const created = new Date(createdAt);
      const deadline = new Date(created.getTime() + 24 * 60 * 60 * 1000);
      const now = new Date();
      const diff = deadline - now;
      
      if (diff <= 0) {
        return { expired: true, hours: 0, minutes: 0 };
      }
      
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      
      return { expired: false, hours, minutes };
    };
    
    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 60000);
    
    return () => clearInterval(timer);
  }, [createdAt]);
  
  if (!timeLeft) return null;
  
  if (timeLeft.expired) {
    return (
      <div className="flex items-center gap-1 text-red-600 bg-red-50 px-2 py-1 rounded text-xs font-medium">
        <AlertTriangle className="w-3 h-3" />
        <span>Verlopen</span>
      </div>
    );
  }
  
  const isUrgent = timeLeft.hours < 4;
  const isWarning = timeLeft.hours < 8 && !isUrgent;
  
  return (
    <div className={`flex items-center gap-1 px-2 py-1 rounded text-xs font-medium ${
      isUrgent ? 'text-red-600 bg-red-50' : 
      isWarning ? 'text-orange-600 bg-orange-50' : 
      'text-green-600 bg-green-50'
    }`}>
      <Timer className="w-3 h-3" />
      <span>{timeLeft.hours}u {timeLeft.minutes}m</span>
    </div>
  );
};

export default CountdownTimer;
